import React, { Component } from 'react';
import Modal from '../../../components/modals';
import Select, { components } from 'react-select';
import { gql } from '@apollo/client';
import _, { functions } from 'lodash';
import { toast } from 'react-toastify';
import ProjectsGraphQl from '../../../../controllers/projectsGraphQl';
import InputHeader from '../../global/inputwithHeader';
import service from '../../../../services/graphQlServices';
import LoadingBar from '../../../components/global/loadingBar';
import Dropzone from 'react-dropzone';
import { ReactComponent as MoreVerticalIcon } from '../../../../assets/svg/Project/more-vertical.svg';
import { ReactComponent as AttachIcon } from '../../../../assets/svg/attachment.svg';
import { ReactComponent as DownIcon } from '../../../../assets/svg/arrow-ios-downward.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/svg/trash3.svg';
import { ReactComponent as CheckedIcon } from '../../../../assets/svg/check-selected.svg';

import { Document, Page, pdfjs } from 'react-pdf';
import moment from 'moment';
import { withRouter } from '../../../../services/withRoute';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
var randomize = require('randomatic');
const prettyBytes = require('pretty-bytes');

const getHardDriveList = gql`
	query VendorHardDriveList($workspaceId: String, $filters: HardDrivesDataInput) {
		vendorHardDriveList(workspaceId: $workspaceId, filters: $filters) {
			data {
				id
				qrCode
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			nextPage
		}
	}
`;

const addNewBackup = gql`
	mutation AddNewBackup(
		$workspaceId: String!
		$qrCode: String!
		$projectId: ID!
		$eventId: ID!
		$mcBackupLogInput: [McBackupLogInput]
	) {
		addNewBackup(
			workspaceId: $workspaceId
			qrCode: $qrCode
			projectId: $projectId
			eventId: $eventId
			mcBackupLogInput: $mcBackupLogInput
		) {
			message
		}
	}
`;

const uploadProjectFile = gql`
	mutation UploadProjectFile(
		$projectId: ID!
		$uploadInput: FileUploadInput!
		$workspaceId: String
	) {
		uploadProjectFile(
			projectId: $projectId
			uploadInput: $uploadInput
			workspaceId: $workspaceId
		) {
			signedUrl
			fileId
		}
	}
`;

const getFileSignedUrl = gql`
	query RootQuery($workspaceId: ID!, $projectId: ID!, $fileId: ID!) {
		getProjectFileSignedUrl(workspaceId: $workspaceId, projectId: $projectId, fileId: $fileId)
	}
`;

const getFileUploadStatus = gql`
	query VendorFileUploadStatus($workspaceId: ID!, $uploadBatchId: String) {
		vendorFileUploadStatus(workspaceId: $workspaceId, uploadBatchId: $uploadBatchId) {
			uploadedCount
			filesUploaded {
				_id
				fileType
				originalFileName
				s3KeyOriginal
				originalFileSizeInMb
			}
		}
	}
`;

const updateMemoryCardBackupDetails = gql`
	mutation UpdateMCLogDetails(
		$workspaceId: String!
		$qrCode: String!
		$projectId: ID!
		$eventId: ID!
		$updatedMcLogDetails: [UpdateMcBackupLogInput]
	) {
		updateMCLogDetails(
			workspaceId: $workspaceId
			qrCode: $qrCode
			projectId: $projectId
			eventId: $eventId
			updatedMcLogDetails: $updatedMcLogDetails
		) {
			message
		}
	}
`;

const confirmBackupVerification = gql`
	mutation ConfirmBackupVerification(
		$workspaceId: String!
		$qrCode: String!
		$projectId: ID!
		$eventId: ID!
		$hddQrCode: String!
		$files: [DeNormalizedFileInput]
	) {
		confirmBackupVerification(
			workspaceId: $workspaceId
			qrCode: $qrCode
			projectId: $projectId
			eventId: $eventId
			hddQrCode: $hddQrCode
			files: $files
		) {
			message
		}
	}
`;

const detachMCBackupFiles = gql`
	mutation DetachMcFile(
		$workspaceId: String!
		$qrCode: String!
		$projectId: ID!
		$eventId: ID!
		$fileId: ID!
	) {
		detachMcFile(
			workspaceId: $workspaceId
			qrCode: $qrCode
			projectId: $projectId
			eventId: $eventId
			fileId: $fileId
		) {
			message
		}
	}
`;

class RecordMemCardBackup extends ProjectsGraphQl {
	constructor(props) {
		super(props);
		this.state = {
			showDiscardModal: false,
			isAck: false,
			hardDriveNameOptions: [],
			hardDriveNameList: [],
			isHardDriveLoading: false,
			hddId:
				_.has(props, 'backupForModal') && _.has(props.backupForModal, 'hddId')
					? props.backupForModal.hddId
					: '',
			gbTransferred:
				_.has(props, 'backupForModal') && _.has(props.backupForModal, 'backupSize')
					? props.backupForModal.backupSize
					: '',
			path:
				_.has(props, 'backupForModal') && _.has(props.backupForModal, 'backupPath')
					? props.backupForModal.backupPath
					: '',
			numberOfFilesCopied:
				_.has(props, 'backupForModal') && _.has(props.backupForModal, 'numberOfFiles')
					? props.backupForModal.numberOfFiles
					: '',

			//file upload variables
			imageSrc: [],
			files:
				_.has(props, 'backupForModal') && _.has(props.backupForModal, 'files')
					? _.cloneDeep(props.backupForModal.files)
					: [],
			isReadyFilesLoaded: false,
			isFileLoading: false,
			readyToUploadFiles: [],
			uploadFileType: '',
			uploadFileType2: null,
			isUploadComplete: false,
			showFileFile: {},
			showFileSrc: null,
			showFileIndex: -1,
			fileUpload: [],
			uploadBatchId: randomize('Aa0', 11),
			uploadFileErrorCount: 0,
			totalSignedUrlErrorCount: 0,
			isFileSrcLoading: true,
			isAPISubmitting: false,
			backedUpHDD:
				_.has(props, 'selectedMC') && _.has(props.selectedMC, 'backupLogs')
					? _.map(props.selectedMC.backupLogs, (backup) => backup.hddQrCode)
					: [],
		};
	}

	timer = null;

	DropdownIndicator = (props) => {
		return (
			<components.DropdownIndicator {...props}>
				<DownIcon />
			</components.DropdownIndicator>
		);
	};

	componentDidMount = async () => {
		const hdListVariables = {
			filters: {
				page: 1,
				limit: 100,
				projectId: this.props.params.projectID,
			},
			workspaceId: this.props.params.workspaceID,
		};
		await this.getHardDriveNameList(getHardDriveList, hdListVariables, true);

		let count = 0;
		let files = this.state.files;
		let showFileFile = this.state.showFileFile;
		let showFileSrc = this.state.showFileSrc;
		let showFileIndex = this.state.showFileIndex;
		while (count < _.size(files)) {
			let getSignedUrlVariables = {
				fileId: files[count]._id,
				workspaceId: this.props.params.workspaceID,
				projectId: this.props.params.projectID,
			};

			let res = await this.getFileSignedUrl(getFileSignedUrl, getSignedUrlVariables);
			if (res !== false) {
				if (count === 0) {
					showFileFile = files[count];
					showFileSrc = res;
					showFileIndex = files[count]._id;
				}
				files[count].src = res;
			}

			count = count + 1;
		}
		this.setState({
			files,
			isFileSrcLoading: false,
			showFileFile,
			showFileSrc,
			showFileIndex,
		});
	};

	componentWillUnmount() {
		if (this.timer) {
			clearInterval(this.timer);
		}
	}

	handleCloseModal = () => {
		if (
			this.props.recordType === '' ||
			this.props.recordType === 'ready' ||
			this.props.recordType === 'formatPending'
		) {
			this.props.close();
		} else if (
			this.props.recordType === 'record' ||
			this.props.recordType === 'verificationPending' ||
			this.props.recordType === 'backupPending'
		) {
			this.setState({ showDiscardModal: true });
		}
	};

	checkUploadStatus = () => {
		let fileVariables = {
			uploadBatchId: this.state.uploadBatchId,
			workspaceId: this.props.params.workspaceID,
		};
		let failCounter = 0;
		let complete = false;
		let completedFiles = [];
		let processing = false;
		let counter = 0;
		let isAPICalled = false;
		this.timer = setInterval(async () => {
			counter += 1;
			if (processing === false) {
				processing = true;
				let file = await this.getFileInfo(getFileUploadStatus, fileVariables);
				if (file !== false) {
					failCounter = 0;
					if (file.uploadedCount > 0 && complete === false && isAPICalled === false) {
						let uploadedCount = file.uploadedCount;
						if (
							file.uploadedCount + this.state.totalSignedUrlErrorCount ===
							_.size(this.state.fileUpload)
						) {
							complete = true;
						}
						let filesUploaded = file.filesUploaded;
						for (let file of filesUploaded) {
							let found = undefined;
							found = _.find(completedFiles, { _id: file._id });

							if (found) {
								continue;
							}
							completedFiles.push(file);

							let files = this.state.files;
							let fileUpload = this.state.fileUpload;
							delete file['__typename'];

							let foundIndex = -1;
							foundIndex = _.findIndex(fileUpload, { id: file._id });
							if (foundIndex !== -1) {
								fileUpload[foundIndex].isUploading = false;
								fileUpload[foundIndex].isSuccess = true;
								file.fileType = fileUpload[foundIndex].type2;
							}
							let getSignedUrlVariables = {
								fileId: file._id,
								workspaceId: this.props.params.workspaceID,
							};

							getSignedUrlVariables.projectId = this.props.params.projectID;

							let res = await this.getFileSignedUrl(
								getFileSignedUrl,
								getSignedUrlVariables,
							);

							if (res !== false) {
								file.src = res;
							} else {
								file.src = null;
							}

							files.push(file);

							this.setState({ files, fileUpload }, () => {
								if (
									_.size(completedFiles) + this.state.totalSignedUrlErrorCount ===
										_.size(this.state.fileUpload) &&
									isAPICalled === false
								) {
									isAPICalled = true;
									this.setState({
										isUploadComplete: true,
										isFileLoading: false,
										fileUpload: [],
										readyToUploadFiles: [],
										isReadyFilesLoaded: false,
									});

									if (this.props.recordType === 'record') {
										this.handleSubmitRecordMCBackup();
									} else if (
										this.props.recordType === 'verificationPending' ||
										this.props.recordType === 'backupPending'
									) {
										this.handleVerifySingleBackupLog();
									}

									clearInterval(this.timer);
								}
							});
						}
					}
					processing = false;
				} else {
					failCounter += 1;
					if (failCounter > 9) {
						this.uploadFailedCompute();
						clearInterval(this.timer);
					}
					processing = false;
				}
			}
		}, 1000);
	};

	uploadFailedCompute = () => {
		let fileUpload = this.state.fileUpload;

		fileUpload = _.map(fileUpload, (item, index) => {
			item.isUploading = false;
			if (item.isSuccess === true) {
				return item;
			} else {
				item.isSuccess = false;
			}
			return item;
		});

		this.setState({
			isFileLoading: false,
			fileUpload,
			isUploadComplete: true,
		});
	};

	uploadFile = async (mutation, variables, files, index) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response;
		let fileUpload = this.state.fileUpload;
		try {
			response = await service.mutation(mutation, variables, vendorID, usertoken, 'vendors');
		} catch (e) {
			fileUpload[index].isSignedUrlError = true;
		}
		if (response[0] === true) {
			fileUpload[index].signedUrl = response[1].data.uploadProjectFile['signedUrl'];
			fileUpload[index].id = response[1].data.uploadProjectFile['fileId'];
		} else {
			fileUpload[index].isSignedUrlError = true;
		}
		this.setState({ fileUpload }, async () => {
			let isComplete = _.every(fileUpload, (fi, inx) => {
				if (fi.signedUrl !== null || fi.isSignedUrlError == true) {
					return true;
				} else {
					return false;
				}
			});
			if (isComplete) {
				let totalSignedUrlErrorCount = _.size(
					_.filter(fileUpload, { isSignedUrlError: true }),
				);
				this.setState({ totalSignedUrlErrorCount, uploadFileErrorCount: 0 }, async () => {
					let isFirst = true;
					let inx = 0;
					for (let f of files) {
						if (fileUpload[inx].isSignedUrlError === true) {
							return;
						}
						if (isFirst === true) {
							isFirst = false;
							this.checkUploadStatus();
						}
						let res = false;
						res = await this.axiosPutFileCallToS3Bucket(f, fileUpload[inx].signedUrl);
						if (res === true) {
						} else {
							this.setState({
								uploadFileErrorCount: this.state.uploadFileErrorCount + 1,
							});
						}
						inx += 1;
					}
				});
			}
		});
	};

	readUploadingFile = (file, index, size) => {
		let reader = new FileReader();

		reader.onload = (e) => {
			let fileUpload = this.state.fileUpload;
			fileUpload[index].src = reader.result;

			if (
				this.props.recordType === 'record' &&
				this.state.showFileIndex === -1 &&
				index === 0
			) {
				let showFileFile = { type: this.state.readyToUploadFiles[index].type };
				let showFileSrc = fileUpload[index].src;
				let showFileIndex = index;

				this.setState({ showFileFile, showFileSrc, showFileIndex });
			}
			this.setState({ fileUpload });
			if (index + 1 === size) {
				this.setState({
					//isFileLoading: true,
					isReadyFilesLoaded: true,
					isUploadComplete: false,
				});
			}
		};
		reader.readAsDataURL(file);
	};

	onDrop = async (files) => {
		let fileUpload = this.state.fileUpload;
		let initialFileUploadSize = _.size(this.state.fileUpload);
		let uploadBatchId = this.state.uploadBatchId;
		let readyToUploadFiles = this.state.readyToUploadFiles;
		let inx = initialFileUploadSize;
		for (let f of files) {
			readyToUploadFiles.push(f);
			fileUpload.push({
				signedUrl: null,
				id: null,
				type: '',
				type2: '',
				src: null,
				isSuccess: false,
				isUploading: true,
				isSignedUrlError: false,
				originalFileName: f.name,
				originalFileSizeInMb: f.size,
				originalDateTime: moment(f['originalDate']).unix(),
				uploadBatchId: this.state.uploadBatchId,
			});
			if (f.type === 'application/pdf') {
				fileUpload[inx].type = 'pdf';
				fileUpload[inx].type2 = 'pdf';
			} else if (f.type === 'image/jpeg' || f.type === 'image/png') {
				fileUpload[inx].type = 'image';
				if (f.type === 'image/jpeg') {
					fileUpload[inx].type2 = 'jpeg';
				} else if (f.type === 'image/png') {
					fileUpload[inx].type2 = 'png';
				}
			}
			inx += 1;
		}

		inx = 0;
		this.setState(
			{ fileUpload, uploadBatchId, uploadFileErrorCount: 0, readyToUploadFiles },
			() => {
				for (let f of files) {
					this.readUploadingFile(
						f,
						_.size(fileUpload) - _.size(files) + inx,
						_.size(fileUpload),
					);
					inx += 1;
				}
			},
		);
	};

	startUploadingFiles = async () => {
		this.setState({ isAPISubmitting: true });
		let inx = 0;
		for (let f of this.state.fileUpload) {
			let uploadVariables = {
				workspaceId: this.props.params.workspaceID,
				projectId: this.props.params.projectID,
				uploadInput: {
					originalFileName: f.originalFileName,
					originalDateTime: f.originalDateTime,
					uploadBatchId: f.uploadBatchId,
				},
			};

			let res = await this.uploadFile(
				uploadProjectFile,
				uploadVariables,
				this.state.readyToUploadFiles,
				inx,
			);

			inx += 1;
		}
	};

	handleDeleteUploadReadyFile = async (index) => {
		let readyToUploadFiles = this.state.readyToUploadFiles;
		let fileUpload = this.state.fileUpload;
		fileUpload.splice(index, 1);
		readyToUploadFiles.splice(index, 1);
		if (index === this.state.showFileIndex) {
			this.setState({
				showFileIndex: -1,
				showFileFile: {},
				showFileSrc: null,
			});
		}
		this.setState({ readyToUploadFiles, fileUpload });
	};

	handleSubmitRecordMCBackup = () => {
		let files = _.map(this.state.files, (item) => {
			delete item['src'];
			return item;
		});
		let json = {
			qrCode: _.has(this.props, 'qrCode') ? this.props.qrCode : this.state.qrCode,
			workspaceId: this.props.params.workspaceID,
			projectId: this.props.params.projectID,
			eventId: this.props.params.shootID,
			mcBackupLogInput: Array.isArray(this.state.hddId)
				? _.map(this.state.hddId, (item, index) => {
						return {
							backupSize: parseFloat(this.state.gbTransferred),
							backupPath: this.state.path,
							files,
							hddId: item.value,
							hddQrCode: item.label,
							numberOfFiles: this.state.numberOfFilesCopied,
						};
				  })
				: [
						{
							backupSize: parseFloat(this.state.gbTransferred),
							backupPath: this.state.path,
							files,
							hddId: this.state.hddId,
							hddQrCode: _.find(this.state.hardDriveNameOptions, {
								value: this.state.hddId,
							}).label,
							numberOfFiles: this.state.numberOfFilesCopied,
						},
				  ],
		};

		this.recordMemoryCardBackup(addNewBackup, json);
	};

	checkFilesChangesBeforeHandleVerifySingleBackupLog = () => {
		this.setState({ isAPISubmitting: true });
		if (_.size(this.state.fileUpload) > 0) {
			this.startUploadingFiles();
		} else {
			this.handleVerifySingleBackupLog();
		}
	};

	handleVerifySingleBackupLog = async () => {
		let anyFileDeleted = false;
		let res = true;
		let tempDeletedFiles = _.filter(this.props.backupForModal.files, (file, index) => {
			let found = -1;
			found = _.findIndex(this.state.files, { _id: file._id });
			if (found === -1) {
				return true;
			} else {
				return false;
			}
		});

		let deleteFileFaileCount = 0;
		if (_.size(tempDeletedFiles) > 0) {
			for (let f of tempDeletedFiles) {
				let json = {
					qrCode: this.props.qrCode,
					workspaceId: this.props.params.workspaceID,
					projectId: this.props.params.projectID,
					eventId: this.props.params.shootID,
					fileId: f._id,
				};

				let tempRes = await this.updateDeleteAddProjectCollaborator(
					detachMCBackupFiles,
					json,
				);

				if (tempRes === false) {
					deleteFileFaileCount += 1;
				}

				if (res === true && tempRes === false) {
					res = false;
				}
			}

			if (res === false) {
				await toast.promise(
					new Promise(async (resolve, reject) => {
						reject(`Failed to delete ${deleteFileFaileCount} memory card backup file!`);
					}),
					{
						pending: 'Loading',
						success: ``,
						error: `Failed to delete ${deleteFileFaileCount} memory card backup file!`,
					},
					{
						theme: 'colored',
						autoClose: 500,
					},
				);
			}
		}

		let updateMCLogsVariables = {
			qrCode: this.props.qrCode,
			workspaceId: this.props.params.workspaceID,
			projectId: this.props.params.projectID,
			eventId: this.props.params.shootID,
			updatedMcLogDetails: [
				{
					currrentHddQrCode: this.props.backupForModal.hddQrCode,
				},
			],
		};

		if (this.props.backupForModal.hddId !== this.state.hddId) {
			updateMCLogsVariables.updatedMcLogDetails[0].currrentHddQrCode =
				this.props.backupForModal.hddQrCode;
			updateMCLogsVariables.updatedMcLogDetails[0].hddId = this.state.hddId;
			updateMCLogsVariables.updatedMcLogDetails[0].hddQrCode = _.find(
				this.state.hardDriveNameOptions,
				{ value: this.state.hddId },
			).label;
		}

		if (this.props.backupForModal.backupSize !== parseFloat(this.state.gbTransferred)) {
			updateMCLogsVariables.updatedMcLogDetails[0].backupSize = parseFloat(
				this.state.gbTransferred,
			);
		}

		if (this.props.backupForModal.backupPath !== this.state.path) {
			updateMCLogsVariables.updatedMcLogDetails[0].backupPath = this.state.path;
		}

		if (this.props.backupForModal.numberOfFiles !== this.state.numberOfFilesCopied) {
			updateMCLogsVariables.updatedMcLogDetails[0].numberOfFiles =
				this.state.numberOfFilesCopied;
		}

		res = true;
		if (
			this.props.backupForModal.hddId !== this.state.hddId ||
			this.props.backupForModal.backupSize !== parseFloat(this.state.gbTransferred) ||
			this.props.backupForModal.backupPath !== this.state.path ||
			this.props.backupForModal.numberOfFiles !== this.state.numberOfFilesCopied
		) {
			res = await this.updateDeleteAddProjectCollaborator(
				updateMemoryCardBackupDetails,
				updateMCLogsVariables,
			);
		}

		if (res === false) {
			await toast.promise(
				new Promise(async (resolve, reject) => {
					reject(
						this.props.recordType === 'backupPending'
							? 'Memory Card backup update failed!'
							: 'Memory Card backup verification failed!',
					);
				}),
				{
					pending: 'Loading',
					success:
						this.props.recordType !== 'verificationPending'
							? `Memory Card backup updated!`
							: '',
					error:
						this.props.recordType === 'backupPending'
							? 'Memory Card backup update failed!'
							: `Memory Card backup verification failed!`,
				},
				{
					theme: 'colored',
					autoClose: 500,
				},
			);

			return;
		} else {
			if (this.props.recordType === 'backupPending') {
				await toast.promise(
					new Promise(async (resolve, reject) => {
						resolve(true);
					}),
					{
						pending: 'Loading',
						success:
							this.props.recordType !== 'verificationPending'
								? `Memory Card backup updated!`
								: '',
						error: '',
					},
					{
						theme: 'colored',
						autoClose: 500,
					},
				);
			}
		}

		let json = {
			qrCode: this.props.qrCode,
			workspaceId: this.props.params.workspaceID,
			projectId: this.props.params.projectID,
			eventId: this.props.params.shootID,
			hddQrCode:
				this.props.backupForModal.hddId !== this.state.hddId && this.state.hddId !== null
					? _.find(this.state.hardDriveNameOptions, { value: this.state.hddId }).label
					: this.props.backupForModal.hddQrCode,
		};

		if (
			_.size(
				_.filter(this.state.files, (file, inx) => {
					let found = -1;
					found = _.findIndex(this.props.backupForModal.files, { _id: file._id });
					if (found === -1) {
						return true;
					} else {
						return false;
					}
				}),
			) > 0
		) {
			json.files = _.filter(this.state.files, (file, inx) => {
				let found = -1;
				found = _.findIndex(this.props.backupForModal.files, { _id: file._id });
				if (found === -1) {
					return true;
				} else {
					return false;
				}
			});

			json.files = _.filter(json.files, (item) => {
				delete item.src;
				return item;
			});
		}

		if (this.props.recordType === 'backupPending') {
			if (_.size(json.files) > 0) {
				let updateMCLogsVariables = {
					qrCode: this.props.qrCode,
					workspaceId: this.props.params.workspaceID,
					projectId: this.props.params.projectID,
					eventId: this.props.params.shootID,
					updatedMcLogDetails: [
						{
							currrentHddQrCode:
								this.props.backupForModal.hddId !== this.state.hddId &&
								this.state.hddId !== null
									? _.find(this.state.hardDriveNameOptions, {
											value: this.state.hddId,
									  }).label
									: this.props.backupForModal.hddQrCode,
							files: json.files,
						},
					],
				};

				this.updateMcBackupLogs(
					updateMemoryCardBackupDetails,
					updateMCLogsVariables,
					res !== false ? true : null,
				);
			} else {
				if (_.has(this.props, 'onMCBackedUp')) {
					this.props.onMCBackedUp();
				}
				if (_.has(this.props, 'close')) {
					this.props.close();
				}
			}
		} else if (this.props.recordType === 'verificationPending') {
			this.confirmBackupVerification(confirmBackupVerification, json);
		}
	};

	deleteMCFile = (key, index) => {
		let files = this.state.files;

		if (this.state.showFileIndex === key) {
			this.setState({
				showFileFile: {},
				showFileIndex: -1,
				showFileSrc: null,
			});
		}
		files.splice(index, 1);

		this.setState({
			files,
		});
	};

	handleSelectHardDisk = (e) => {
		if (Array.isArray(e)) {
			this.setState({
				hddId: _.filter(e, (item) => item.value !== null),
			});
		} else {
			this.setState({
				hddId: e.value,
				hddQrCode: e.label,
			});
		}
	};

	render() {
		let backedUpHDD = this.state.backedUpHDD;

		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'center'}
			>
				<div className="mc-record-center-modal">
					<div className="mc-record-header">
						<span className="header-title">
							{this.props.recordType === 'verificationPending'
								? 'VERIFY'
								: this.props.recordType === 'formatPending'
								? 'RECORD'
								: this.props.recordType === 'backupPending'
								? 'UPDATE'
								: ''}{' '}
							MEMORY CARD BACKUP
						</span>
					</div>
					{(this.props.recordType === 'backupPending' ||
						this.props.recordType === 'verificationPending' ||
						this.props.recordType === 'formatPending') &&
					this.state.isFileSrcLoading ? (
						<LoadingBar />
					) : (
						<>
							<div className="mc-record-body">
								<div className="mc-record-body-left-right">
									<div className="left-item-container">
										<div className="floating-select-container">
											<label>
												Memory Card<span className="required-star">*</span>
											</label>
											<Select
												className={'cost-select-container zIndex5 w-100p'}
												classNamePrefix="cost-select"
												options={_.map(
													[
														..._.filter(this.props.memoryCardsList, {
															isEmpty: null,
															isReceived: true,
														}),
														..._.filter(this.props.memoryCardsList, {
															isEmpty: false,
															isReceived: true,
														}),
													],
													(mc, key) => {
														return {
															label: mc.qrCode,
															value: mc.qrCode,
															memoryCard: mc,
														};
													},
												)}
												onChange={(e) =>
													this.setState({
														qrCode: e.value,
														selectedMC: e.memoryCard,
														backedUpHDD: _.has(
															e.memoryCard,
															'backupLogs',
														)
															? _.map(
																	e.memoryCard.backupLogs,
																	(backup) => backup.hddQrCode,
															  )
															: [],
													})
												}
												defaultValue={
													_.has(this.props, 'qrCode')
														? {
																label: this.props.qrCode,
																value: this.props.qrCode,
														  }
														: null
												}
												components={{
													DropdownIndicator: this.DropdownIndicator,
												}}
												isLoading={this.state.isHardDriveLoading}
												isDisabled={
													this.state.isAPISubmitting === true ||
													this.props.recordType === '' ||
													_.has(this.props, 'qrCode') ||
													(_.has(this.props, 'backupForModal') &&
														_.has(
															this.props.backupForModal,
															'isVerified',
														) &&
														this.props.backupForModal.isVerified ===
															true)
												}
												isSearchable={true}
											/>
										</div>
									</div>
									<div className="left-item-container">
										<div className="floating-select-container">
											<label>
												Hard Drive<span className="required-star">*</span>
											</label>
											<Select
												className={'cost-select-container zIndex4 w-100p'}
												classNamePrefix="cost-select"
												options={_.filter(
													this.state.hardDriveNameOptions,
													function (hdd) {
														return (
															_.indexOf(backedUpHDD, hdd.label) === -1
														);
													},
												)}
												onChange={
													(e) => this.handleSelectHardDisk(e)
													/* this.setState({
														hddId: e.value,
														hddQrCode: e.label,
													}) */
												}
												defaultValue={
													this.props.recordType === 'record'
														? _.find(this.state.hardDriveNameOptions, {
																value: this.state.hddId,
														  })
														: _.has(this.props, 'backupForModal')
														? {
																value: this.props.backupForModal
																	.hddQrCode,
																label: this.props.backupForModal
																	.hddQrCode,
														  }
														: null
												}
												components={{
													DropdownIndicator: this.DropdownIndicator,
												}}
												isLoading={this.state.isHardDriveLoading}
												isDisabled={
													(_.has(this.props, 'backupForModal') &&
														_.has(
															this.props.backupForModal,
															'hddQrCode',
														)) ||
													this.state.isAPISubmitting === true ||
													this.props.recordType === '' ||
													this.props.recordType ===
														'verificationPending' ||
													(_.has(this.props, 'backupForModal') &&
														_.has(
															this.props.backupForModal,
															'isVerified',
														) &&
														this.props.backupForModal.isVerified ===
															true)
												}
												isSearchable={true}
												isMulti={this.props.recordType === 'record'}
											/>
											<p style={{ color: 'red', fontSize: '10px' }}>
												{_.indexOf(
													this.state.backedUpHDD,
													this.state.hddQrCode,
												) >= 0
													? 'Data already copied'
													: ''}
											</p>
										</div>
									</div>
									<div className="left-item-container">
										<InputHeader
											type="text"
											name="dataTransferredInGB"
											isInputError={false}
											label="Data Copied in GB"
											value={this.state.gbTransferred}
											onChange={(e) => {
												if (isNaN(e.target.value)) {
													this.setState({ gbTransferred: '' });
												} else {
													this.setState({
														gbTransferred: e.target.value,
													});
												}
											}}
											errorMessage={''}
											width="100%"
											marginBottom="0px"
											required={true}
											readOnly={
												this.state.isAPISubmitting === true ||
												this.props.recordType === '' ||
												(_.has(this.props, 'backupForModal') &&
													_.has(
														this.props.backupForModal,
														'isVerified',
													) &&
													this.props.backupForModal.isVerified === true)
											}
										/>
									</div>
									<div className="left-item-container">
										<InputHeader
											type="text"
											name="numberOfFilesCopied"
											isInputError={false}
											label="Number of files copied"
											value={this.state.numberOfFilesCopied}
											onChange={(e) => {
												if (isNaN(e.target.value)) {
													this.setState({ numberOfFilesCopied: '' });
												} else {
													this.setState({
														numberOfFilesCopied: e.target.value,
													});
												}
											}}
											errorMessage={''}
											width="100%"
											marginBottom="0px"
											required={true}
											readOnly={
												this.state.isAPISubmitting === true ||
												this.props.recordType === '' ||
												(_.has(this.props, 'backupForModal') &&
													_.has(
														this.props.backupForModal,
														'isVerified',
													) &&
													this.props.backupForModal.isVerified === true)
											}
										/>
									</div>
									<div className="left-item-container">
										<InputHeader
											type="text"
											name="pathUrl"
											isInputError={false}
											label="Path URL"
											value={this.state.path}
											onChange={(e) => {
												this.setState({ path: e.target.value });
											}}
											width="100%"
											required={true}
											marginBottom="0px"
											readOnly={
												this.state.isAPISubmitting === true ||
												this.props.recordType === '' ||
												(_.has(this.props, 'backupForModal') &&
													_.has(
														this.props.backupForModal,
														'isVerified',
													) &&
													this.props.backupForModal.isVerified === true)
											}
										/>
									</div>
									<div className="left-item-container" style={{ height: 'auto' }}>
										<div className="attachment-label">
											<span>Attachments</span>
											<span className="required-text">*</span>
										</div>
										<Dropzone
											onDrop={this.onDrop}
											accept={'image/jpeg, image/png, application/pdf'}
											multiple={true}
											disabled={
												this.state.isAPISubmitting === true ||
												this.state.isFileLoading ||
												this.props.recordType === '' ||
												(_.has(this.props, 'backupForModal') &&
													_.has(
														this.props.backupForModal,
														'isVerified',
													) &&
													this.props.backupForModal.isVerified === true)
											}
										>
											{({ getRootProps, getInputProps }) => (
												<div
													className="upload-border-container"
													{...getRootProps({})}
												>
													<span className="upload-icn">
														<AttachIcon />
													</span>
													<span
														className={
															'upload-text' +
															(this.state.isFileLoading ||
															this.props.recordType === '' ||
															this.props.recordType === 'ready' ||
															this.props.recordType ===
																'formatPending' ||
															(this.props.recordType ===
																'verificationPending' &&
																this.props.backupForModal
																	.isVerified === true)
																? ' disabled'
																: '')
														}
													>
														Upload files
														<input {...getInputProps()} />
													</span>
												</div>
											)}
										</Dropzone>
										<div className="uploaded-files-container">
											<>
												{_.map(this.state.files, (file, index) => {
													return (
														<div
															key={`sjdflksjdf2367567${index}`}
															className={
																'uploaded-files-image-bg' +
																(this.state.showFileIndex === index
																	? ' selected'
																	: '')
															}
															style={
																file.fileType === 'jpeg' ||
																file.fileType === 'png'
																	? {
																			backgroundImage: `url(${file.src})`,
																	  }
																	: {}
															}
														>
															{file.fileType === 'pdf' ? (
																<Document
																	file={file.src}
																	error=""
																	loading={
																		<div className="loading-indicator-fg">
																			<LoadingBar />
																		</div>
																	}
																>
																	<Page
																		pageNumber={1}
																		width={120}
																	/>
																</Document>
															) : null}
															<div
																className="uploaded-files-image-fg"
																onClick={() => {
																	this.setState({
																		showFileFile: file,
																		showFileSrc: file.src,
																		showFileIndex: file._id,
																	});
																}}
															>
																<div className="uploaded-files-text">
																	{file.originalFileName}
																</div>
																<div className="uploaded-lower-details">
																	<span className="size-indicator">
																		{prettyBytes(
																			file.originalFileSizeInMb,
																		)}
																	</span>
																	{(this.props.recordType ===
																		'verificationPending' &&
																		this.props.backupForModal
																			.isVerified ===
																			false) ||
																	this.props.recordType ===
																		'backupPending' ? (
																		<span
																			className="delete-icn"
																			onClick={(e) =>
																				this.deleteMCFile(
																					file._id,
																					index,
																				)
																			}
																		>
																			<DeleteIcon />
																		</span>
																	) : null}
																</div>
															</div>
														</div>
													);
												})}
											</>
											{this.state.isReadyFilesLoaded &&
											!this.state.isFileLoading ? (
												<>
													{_.map(this.state.fileUpload, (file, index) => {
														if (file.isSuccess === true) {
															return null;
														}
														return (
															<div
																className={
																	'uploaded-files-image-bg' +
																	(this.state.showFileIndex ===
																	index
																		? ' selected'
																		: '')
																}
																key={`spodfj3489usiodjejfhois1s${index}`}
																style={
																	file.type === 'pdf'
																		? {}
																		: {
																				backgroundImage: `url(${file.src})`,
																		  }
																}
															>
																{file.type === 'pdf' ? (
																	<Document
																		file={file.src}
																		error=""
																		loading={
																			<div className="loading-indicator-fg">
																				<LoadingBar />
																			</div>
																		}
																	>
																		<Page
																			pageNumber={1}
																			width={120}
																		/>
																	</Document>
																) : null}
																<div
																	className="uploaded-files-image-fg"
																	onClick={() => {
																		this.setState({
																			showFileFile: file,
																			showFileSrc: file.src,
																			showFileIndex: index,
																		});
																	}}
																>
																	<div className="uploaded-files-text">
																		{file.originalFileName}
																	</div>
																	<div className="uploaded-lower-details">
																		<span className="size-indicator">
																			{prettyBytes(
																				file.originalFileSizeInMb,
																			)}
																		</span>
																		<span
																			className="delete-icn"
																			onClick={(e) => {
																				e.stopPropagation();
																				this.handleDeleteUploadReadyFile(
																					index,
																				);
																			}}
																		>
																			<DeleteIcon />
																		</span>
																	</div>
																</div>
															</div>
														);
													})}
												</>
											) : null}
											{this.state.isFileLoading ? (
												<>
													{_.map(this.state.fileUpload, (file, index) => {
														if (file.isSuccess === true) {
															return null;
														}
														return (
															<div
																className={
																	'uploaded-files-image-bg' +
																	(this.state.showFileIndex ===
																	index
																		? ' selected'
																		: '')
																}
																style={
																	file.type === 'pdf'
																		? {}
																		: {
																				backgroundImage: `url(${file.src})`,
																		  }
																}
															>
																{file.type === 'pdf' ? (
																	<Document
																		file={file.src}
																		error=""
																		loading={
																			<div className="loading-indicator-fg">
																				<LoadingBar />
																			</div>
																		}
																	>
																		<Page
																			pageNumber={1}
																			width={120}
																		/>
																	</Document>
																) : (
																	<div className="loading-indicator-fg">
																		<LoadingBar />
																	</div>
																)}
															</div>
														);
													})}
												</>
											) : null}
											{this.state.uploadFileErrorCount +
												this.state.totalSignedUrlErrorCount >
											0 ? (
												<div className="upload-error-text">
													{this.state.uploadFileErrorCount +
														this.state.totalSignedUrlErrorCount}{' '}
													attachment failed to upload, try again
												</div>
											) : null}
										</div>
									</div>
								</div>
								<div className="mc-record-body-left-right" style={{ width: '60%' }}>
									<div className="attachment-preview-text">
										Attachment preview
									</div>
									<div className="attachment-preview-img">
										{this.state.showFileFile &&
										this.state.showFileSrc !== null &&
										_.has(this.state.showFileFile, 'type2') ? (
											<>
												{this.state.showFileFile.type2 === 'pdf' ? (
													<Document
														file={this.state.showFileSrc}
														error=""
														loading={<LoadingBar />}
													>
														<Page pageNumber={1} width="354" />
													</Document>
												) : this.state.showFileFile.type2 === 'jpeg' ||
												  this.state.showFileFile.type2 === 'png' ? (
													<img src={this.state.showFileSrc} />
												) : null}
											</>
										) : this.state.showFileFile &&
										  this.state.showFileSrc !== null &&
										  _.has(this.state.showFileFile, 'fileType') ? (
											<>
												{this.state.showFileFile.fileType === 'pdf' ? (
													<Document
														file={this.state.showFileSrc}
														error=""
														loading={<LoadingBar />}
													>
														<Page pageNumber={1} width="354" />
													</Document>
												) : this.state.showFileFile.fileType === 'jpeg' ||
												  this.state.showFileFile.fileType === 'png' ? (
													<img src={this.state.showFileSrc} />
												) : null}
											</>
										) : this.state.showFileFile &&
										  this.state.showFileSrc !== null &&
										  _.has(this.state.showFileFile, 'type') ? (
											<>
												{this.state.showFileFile.type ===
												'application/pdf' ? (
													<Document
														file={this.state.showFileSrc}
														error=""
														loading={<LoadingBar />}
													>
														<Page pageNumber={1} width="354" />
													</Document>
												) : this.state.showFileFile.type === 'image/jpeg' ||
												  this.state.showFileFile.type === 'image/png' ? (
													<img src={this.state.showFileSrc} />
												) : null}
											</>
										) : null}
									</div>
								</div>
							</div>
							<div className="mc-record-tail">
								{this.props.recordType === '' ||
								this.props.recordType === 'ready' ||
								(this.props.recordType === 'verificationPending' &&
									this.props.backupForModal.isVerified === true) ||
								this.props.recordType === 'formatPending' ? null : (
									<div
										className="acknowledge-container"
										onClick={() => {
											if (
												(parseFloat(this.state.gbTransferred) <= 0 ||
													this.state.gbTransferred) &&
												this.state.hddId &&
												this.state.numberOfFilesCopied &&
												this.state.path &&
												this.state.isAPISubmitting === false
											)
												this.setState({ isAck: !this.state.isAck });
										}}
									>
										{this.state.isAck ? (
											<span className="check-icon">
												<CheckedIcon />
											</span>
										) : (
											<span className="empty-check"></span>
										)}
										<span className="ack-text">
											I confirm all details entered are correct.
										</span>
									</div>
								)}
								<div className="button-container">
									<span
										className="cancel-btn"
										onClick={() =>
											this.state.isAPISubmitting === false &&
											this.handleCloseModal()
										}
									>
										{(this.props.recordType === 'verificationPending' &&
											this.props.backupForModal.isVerified === true) ||
										this.props.recordType === 'formatPending' ||
										this.props.recordType === 'ready'
											? 'Close'
											: 'Cancel'}
									</span>
									{this.state.isAPISubmitting === true ? (
										<span className={'confirm-btn active loading-btn'}>
											<LoadingBar />
										</span>
									) : (
										<span
											className={
												'confirm-btn' +
												((this.props.recordType === 'record' &&
													this.state.gbTransferred &&
													this.state.hddId &&
													this.state.numberOfFilesCopied &&
													this.state.path &&
													this.state.isAck &&
													_.size(this.state.readyToUploadFiles) > 0) ||
												((this.props.recordType === 'verificationPending' ||
													this.props.recordType === 'backupPending') &&
													this.state.isAck &&
													(this.state.gbTransferred !== null ||
														this.state.gbTransferred !== undefined) &&
													(this.state.numberOfFilesCopied !== null ||
														this.state.numberOfFilesCopied !==
															undefined) &&
													this.state.path &&
													this.state.hddId &&
													(_.size(this.state.readyToUploadFiles) > 0 ||
														_.size(this.state.files) > 0) &&
													(this.props.backupForModal.isVerified ===
														false ||
														this.props.recordType === 'backupPending'))
													? ' active'
													: '')
											}
											onClick={() => {
												if (
													this.props.recordType === 'record' &&
													this.state.gbTransferred &&
													this.state.numberOfFilesCopied &&
													this.state.hddId &&
													this.state.isAck &&
													this.state.path &&
													_.size(this.state.readyToUploadFiles) > 0
												) {
													this.startUploadingFiles();
												} else if (
													(this.props.recordType ===
														'verificationPending' ||
														this.props.recordType ===
															'backupPending') &&
													this.state.isAck &&
													(this.state.gbTransferred !== null ||
														this.state.gbTransferred !== undefined) &&
													(this.state.numberOfFilesCopied !== null ||
														this.state.numberOfFilesCopied !==
															undefined) &&
													this.state.path &&
													this.state.hddId &&
													(_.size(this.state.readyToUploadFiles) > 0 ||
														_.size(this.state.files) > 0) &&
													(this.props.backupForModal.isVerified ===
														false ||
														this.props.recordType === 'backupPending')
												) {
													this.checkFilesChangesBeforeHandleVerifySingleBackupLog();
												}
											}}
										>
											{this.props.recordType === 'verificationPending' &&
											this.props.backupForModal.isVerified === false
												? 'Verify Backup'
												: this.props.recordType === 'record'
												? 'Confirm Backup'
												: this.props.recordType === 'backupPending'
												? 'Update Backup'
												: ''}
										</span>
									)}
								</div>
							</div>
						</>
					)}
				</div>
				<Modal
					handleClose={() => this.setState({ showDiscardModal: false })}
					show={this.state.showDiscardModal}
					modalType={'center'}
				>
					<div className="center-confirm-delete-new">
						<div className="delete-modal-header">DISCARD CHANGES</div>
						<div className="middle-delete-container">
							<div className="middle-text">Are you sure?</div>
							<div className="middle-desc">
								If you discard this information, you cannot undo this
							</div>
						</div>
						<div className="bottom-delete-btns">
							<span
								className="cancel-btn"
								onClick={(e) => this.setState({ showDiscardModal: false })}
							>
								No, Cancel
							</span>
							<span
								className="delete-btn"
								onClick={(e) => {
									this.props.handleClose();
									this.setState({ showDiscardModal: false });
								}}
							>
								Yes, Discard
							</span>
						</div>
					</div>
				</Modal>
			</Modal>
		);
	}
}

export default withRouter(RecordMemCardBackup);
